:host {
    .ti-autocomplete-cpn-container {
        display: flex;
        flex-direction: column;
        gap: $polaris-space-4;
        width: 75%;
    }

    .ti-autocomplete-cpn-enter-cpns-container {
        display: flex;
        flex-direction: column;
        gap: $polaris-space-3;
    }

    .ti-autocomplete-cpn-enter-cpns-textarea {
        padding: $polaris-space-2;
        font-family: $polaris-font-family-tw;
    }

    .ti-autocomplete-cpn-field-required-error {
        display: flex;
        gap: $polaris-space-2;
        align-items: center;
        margin-top: $polaris-space-1;
        color: $pl-error-color;
        font-weight: $polaris-font-weight-normal;
        font-size: $polaris-font-size-body;
    }

    .ti-autocomplete-cpn-progress-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ti-autocomplete-cpn-select {
        width: 100%;
    }

    @include mix-for-sizes-down(phone) {
        .ti-autocomplete-cpn-container {
            width: 100%;
        }
    }

}
